import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '890245410416880';
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Prevent double-injection
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'PageView');
      return;
    }
    /* Standard Meta Pixel base code */
    ;
    (function (f: any, b: Document, e: string, v: string) {
      let n: any, t: HTMLScriptElement, s: Element | null;
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e) as HTMLScriptElement;
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s?.parentNode?.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', PIXEL_ID);
    (window as any).fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-2">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-3" />
    </noscript>;
}